import { render, staticRenderFns } from "./arehousingScanning.vue?vue&type=template&id=274d7a58&scoped=true&"
import script from "./arehousingScanning.vue?vue&type=script&lang=js&"
export * from "./arehousingScanning.vue?vue&type=script&lang=js&"
import style0 from "./arehousingScanning.vue?vue&type=style&index=0&id=274d7a58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d7a58",
  null
  
)

export default component.exports